import React, { Component } from 'react';
import t from 'prop-types';

class ButtonMenu extends Component {
  static propTypes = {
    onClick: t.func,
  };

  render() {
    const { onClick } = this.props;
    return (
      <button
        aria-label="Menu"
        className="wwc-btn-burger header--hide-desktop"
        onClick={onClick}
      >
        <ul className="menu btn-menu">
          <li className="layer">
            <div className="line"></div>
          </li>
          <li className="layer">
            <div className="line"></div>
          </li>
          <li className="layer">
            <div className="line"></div>
          </li>
        </ul>
      </button>
    );
  }
}

export default ButtonMenu;
